import { Component, AfterContentInit, ContentChildren, QueryList, Input, ApplicationRef, NgZone } from '@angular/core';
import { CarouselItemComponent } from '../carousel-item/carousel-item.component'
import { timer } from 'rxjs';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})
export class CarouselComponent implements AfterContentInit {
  @ContentChildren(CarouselItemComponent) cc: QueryList<CarouselItemComponent>;
  index: number = 0;
  max: number;

  @Input() type: 'home' | 'partner';
  @Input() direction: 'left' | 'right' = 'right';

  public constructor(private applicationRef: ApplicationRef, private ngz: NgZone) { }
  ngAfterContentInit(): void {
    this.max = this.cc.length;
    this.cc.forEach(c => c.move = 'inactive');
    this.cc.first.move = 'first';

    if (this.cc.length > 1) {
      this.repeatNext();
    }
  }

  prev() {
    this.cc.toArray()[this.index].move = 'right-out';
    this.index = (this.index == 0 ? this.max : this.index) - 1;
    this.cc.toArray()[this.index].move = 'right-in';
  }

  next() {
    this.cc.toArray()[this.index].move = 'left-out';
    this.index = (this.index + 1) % this.max;
    this.cc.toArray()[this.index].move = 'left-in';
  }

  repeatNext() {
    const t = timer((Math.random() * 2000), 4000);
    t.subscribe(() => {
      if (this.direction == 'right') {
        this.next();
      } else {
        this.prev();
      }
    });
  }


}
